export function AIDecisionNodeFields() {
  return [
    {
      data: {
        field: "textarea"
      },
      hint: "",
      name: "prompt",
      type: "input",
      label: "prompt",
      rules: "required",
      default: "",
      subtype: "",
      version: 2,
      multiple: false,
    },
    {
      data: [],
      hint: "",
      name: "user_id",
      type: "hidden",
      label: "",
      rules: null,
      default: null,
      subtype: "",
      version: 2,
      multiple: false,
    }
  ]
}
